<template>
  <div style="padding:15px;">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Shipment"
};
</script>
